import reduxConnector from 'root/src/shared/util/reduxConnector'

import followerCountSelector from 'root/src/client/logic/userData/selectors/followerCountSelector'
import platformIdSelector from 'root/src/client/logic/userData/selectors/platformIdSelector'
import platformSelector from 'root/src/client/logic/userData/selectors/platformSelector'
import mnemonicIdSelector from 'root/src/client/logic/userData/selectors/mnemonicIdSelector'
import dropEventSelector from 'root/src/client/logic/dropEvent/selectors/dropEventSelector'
import isAdminSelector from 'root/src/client/logic/auth/selectors/isAdminSelector'
import isAuthenticated from 'root/src/client/logic/auth/selectors/isAuthenticated'
import canAccessCreateBrandProjectSelector from 'root/src/client/logic/dropEvent/selectors/canAccessCreateBrandProjectSelector'

import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import redirectAndPrePopulate from 'root/src/client/logic/app/thunks/redirectAndPrePopulate'
import setInput from 'root/src/client/logic/form/thunks/setInput'
import getUserDataSelector from 'root/src/client/logic/api/selectors/getUserDataSelector'
import userIdSelector from 'root/src/client/logic/auth/selectors/userIdSelector'
import tokensSelector from 'root/src/client/logic/api/selectors/tokensSelector'
import creatorCampaignPointsLimitSelector
	from 'root/src/client/logic/app/selectors/creatorCampaignPointsLimitSelector'
import userCampaignDataSelector from 'root/src/client/logic/app/selectors/userCampaignDataSelector'
import { getUserDropEventLandingShortUrl } from 'root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl'
import followerCountByPlatformSelector from 'root/src/client/logic/userData/selectors/followerCountByPlatformsSelector'
import { displayHowToEarnPointsModal } from 'root/src/client/logic/dropEvent/thunks/displayHowToEarnPointsModal'
import { fetchUserCampaignData } from 'root/src/client/logic/app/thunks/fetchUserCampaignData'

export default reduxConnector(
	[
		['followerCount', followerCountSelector],
		['followerCountByPlatforms', followerCountByPlatformSelector],
		['platformId', platformIdSelector],
		['platform', platformSelector],
		['mnemonicId', mnemonicIdSelector],
		['userId', userIdSelector],
		['isAdmin', isAdminSelector],
		['isAuthenticated', isAuthenticated],
		['dropEvent', dropEventSelector],
		['canAccessCreateBrandProject', canAccessCreateBrandProjectSelector],
		['userData', getUserDataSelector],
		['tokens', tokensSelector],
		['creatorCampaignPointsLimit', creatorCampaignPointsLimitSelector],
		['userCampaignData', userCampaignDataSelector],
	],
	[
		['redirectAndPrePopulate', redirectAndPrePopulate],
		['setInput', setInput],
		['displayModal', displayModal],
		['getUserDropEventLandingShortUrl', getUserDropEventLandingShortUrl],
		['displayHowToEarnPointsModal', displayHowToEarnPointsModal],
		['fetchUserCampaignData', fetchUserCampaignData],
	],
)
